import React from 'react'
import { Img } from '../../Image/Img'
import { AccordionHeaderCon } from './styles'

type AccoedionHeaderParams = {
  label: string
  imgUrl?: string
  fallbackImg?: string
  subText?: string
  colorTheme?: 'light' | 'dark' | 'gray'
  size?: 'small' | 'medium' | 'large'
}

export const AccordionHeader: React.FC<AccoedionHeaderParams> = ({
  imgUrl,
  fallbackImg,
  label,
  subText,
  colorTheme = 'light',
  size = 'large',
}) => {
  return (
    <AccordionHeaderCon colorTheme={colorTheme} size={size}>
      {imgUrl && fallbackImg && (
        <Img src={imgUrl} alt="accordian header logo" />
      )}
      {imgUrl && !fallbackImg && <img src={imgUrl} alt="accordian header logo" />}
      <div className="textCon">
        <h1>{label}</h1>
        {subText && <p>{subText}</p>}
      </div>
    </AccordionHeaderCon>
  )
}
